import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import './PrivacyPolicyHero.css';

const PrivacyPolicyHero = () => {
  return (
    <Box className="privacy-hero">
      <div className="privacy-hero-overlay" />
      <Container maxWidth="lg" sx={{ display: 'flex', justifyContent: 'flex-start' }}>
        <motion.div
          className="privacy-hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Typography
            variant="subtitle1"
            className="privacy-hero-subtitle-top"
            component={motion.p}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Our Commitment to Your Privacy
          </Typography>
          <Typography
            variant="h1"
            className="privacy-hero-title"
            component={motion.h1}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            PRIVACY POLICY
          </Typography>
          <Typography
            className="privacy-hero-description"
            component={motion.p}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            Learn how Virves Software Solutions collects, uses, and protects your information. We value your trust and are committed to safeguarding your privacy every step of the way.
          </Typography>
        </motion.div>
      </Container>
    </Box>
  );
};

export default PrivacyPolicyHero; 